const SHOWN = 3;

/** A few of the entities behind a count, with the whole sample on the tooltip. */
export const SampleLine = ({
  label,
  names,
  total,
}: {
  label: string;
  names: string[];
  total: number;
}) => {
  if (names.length === 0) return null;

  const shown = names.slice(0, SHOWN);
  const remaining = total - shown.length;

  return (
    <p className="truncate text-xs text-muted-foreground" title={names.join(", ")}>
      <span className="font-medium">{label}</span>: {shown.join(", ")}
      {remaining > 0 && ` +${remaining} more`}
    </p>
  );
};
